import { DietaryRequirementsService } from "@/clients/services/DietaryRequirementsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetDietaryRequirement = () => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [QueryKeys.DIETARY_REQUIREMENT],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await DietaryRequirementsService.getDietaryRequirementsApiV1DietaryRequirementsGet(
          user.id,
        );

      return data;
    },
  });

  return {
    dietaryRequirement: data,
    isLoading,
    isError,
    error,
  };
};
